import { useEmailProvider } from './useEmailProvider';
import React from 'react';

interface EmailSniperLinkProps {
  email: string;
  children: (inboxUrl: string) => React.ReactElement | null;
}

export const EmailSniperLink: React.FC<EmailSniperLinkProps> = ({
  email,
  children,
}) => {
  const inboxUrl = useEmailProvider(email);

  return children(inboxUrl);
};
